import React, { useContext } from 'react';
import { ValidationGroup } from '@bingads-webui-react/validation';
import { ValidatedLegacyCallToAction } from '@bingads-webui-campaign-react/legacy-call-to-action';
import { AssetGroup } from '@bingads-webui/campaign-odata-schemas';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { PermissionsContext } from '@bingads-webui-react/hoc-with-permissions';

const getStyles = () => ({
  container: {
    position: 'relative',
  },
});

export const CTAInCreativeEditor = ({ newCTA, onValidate }) => {
  const i18n = useContext(I18nContext);

  const classes = useDefaultStyles(getStyles);

  const permissions = useContext(PermissionsContext);

  return (
    <ValidationGroup
      validationProps={{
          schema: AssetGroup,
          onValidate,
          data: newCTA,
          i18n,
          stopPropagation: true,
        }}
      validateOnRender
    >
      <ValidatedLegacyCallToAction
        value={newCTA.CallToAction}
        valueText={newCTA.CallToActionValue}
        ctaText={newCTA.CallToActionText}
        i18n={i18n}
        isCustomCTAEnabled
        className={classes.container}
        permissions={permissions}
      />
    </ValidationGroup>
  );
};
